import { DEFAULT_LOCALE } from 'app-shared/constants';
import { type AppLocale } from 'app-shared/types';
import { isValidLocale } from 'app-shared/utils';

type DetectInitialLocaleArgs = {
  urlLocale: string | null;
  storedLocale: string | null;
  browserLanguages: readonly string[];
  shouldUseBrowserLanguage?: boolean;
};

// French starts fresh sessions; a link or saved personal choice wins.
// Browser language is used only when the person explicitly resets appearance.
export const detectInitialLocale = ({
  urlLocale,
  storedLocale,
  browserLanguages,
  shouldUseBrowserLanguage = false,
}: DetectInitialLocaleArgs): AppLocale => {
  if (isValidLocale(urlLocale)) {
    return urlLocale;
  }

  if (isValidLocale(storedLocale)) {
    return storedLocale;
  }

  if (shouldUseBrowserLanguage) {
    const browserLocale = browserLanguages
      .map((language) => language.split('-')[0])
      .find(isValidLocale);

    return browserLocale ?? DEFAULT_LOCALE;
  }

  return DEFAULT_LOCALE;
};
